import { render, staticRenderFns } from "./CreateRecord.vue?vue&type=template&id=27ad4377"
import script from "./CreateRecord.vue?vue&type=script&lang=js"
export * from "./CreateRecord.vue?vue&type=script&lang=js"
import style0 from "./CreateRecord.vue?vue&type=style&index=0&id=27ad4377&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports